"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popup = void 0;
exports.popup = {
    backgroundColor: 'FFFFFF',
    textColor: '000000',
    confirmButtonStyle: {
        color: 'FFFFFF',
        font: 'bebas',
        fontSize: '18px',
        borderRadius: '40px',
        backgroundColor: '46bb97',
    },
    confirmButtonText: 'CONFIRM',
    closeButtonStyle: {
        color: 'FFFFFF',
        font: 'bebas',
        fontSize: '18px',
        borderRadius: '40px',
        backgroundColor: '58BFEB',
    },
    closeButtonText: 'CLOSE',
    nextButtonStyle: {
        color: 'FFFFFF',
        font: 'bebas',
        fontSize: '18px',
        borderRadius: '40px',
        backgroundColor: '58BFEB',
    },
    nextButtonText: 'NEXT',
    prizePurchaseItemText: 'Item purchased cannot be refunded.',
    prizePurchaseICompletedText: 'You have successfully purchased the item. Please check your email.',
    errorText: 'An unknown error has occurred.\nPlease check your internet\nconnection and try again.',
    coolDownText: 'The selected item is currently locked. Please come back later to check on it.',
    notEnoughCoinsText: 'You do not have enough Coins\nto purchase this item.',
    prizeOutOfStockText: 'This prize is currently out of stock and will be back in the store soon',
    currencyCoolDownText: 'You have earned the maximum amount of coins today. Come back tomorrow to earn more.',
};
